export const loadIndex = (index) => ({
  type: 'LOAD_INDEX',
  index,
})
